import { action, observable } from 'mobx';
import { AmountValue } from 'common/interfaces';
import { RootStore } from 'stores/rootStore';
import { ApiStore } from 'stores/apiStore';
import { API_ACCOUNT_DETAIL_MOVEMENTS, API_ACCOUNT_DETAIL_MOVEMENTS_CSV } from 'api/endpoints';

interface FilterData {
  portfolio: string;
  period: string;
  types: string[];
  options: {
    portfolios: string[];
    periods: string[];
    types: string[];
  };
}

export interface Movement {
  id: string;
  amount: AmountValue;
  date: string;
  portfolio: string;
  type: string;
  isin?: string;
  grouped: boolean;
  items?: Movement[];
}

export interface MovemensData {
  filter: FilterData;
  movements: Movement[];
  from: string;
  to: string;
}

export class MovementsStore {
  rootStore: RootStore;
  accountId: string;
  apiStore: ApiStore;
  @observable data: MovemensData | null;

  @observable generationDialog = false;
  @observable generationDate?: string = undefined;
  @observable generationDrive = false;
  
  constructor(rootStore: RootStore, accountId: string) {
    this.rootStore = rootStore;
    this.accountId = accountId;
    this.apiStore = rootStore.stores.apiStore;
    this.data = null;
  }

  @action hideGenerationDialog = () => (this.generationDialog = false);

  @action fetchData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.apiStore.get<MovemensData>(
      API_ACCOUNT_DETAIL_MOVEMENTS(this.accountId),
    );
    if (response?.data) {
      this.data = response.data;
      this.data.movements = this.data.movements.map((m, i) => ({ ...m, id: `${i}` }));
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };

  @action sendMovementCsv = async () => {
    const { post } = this.rootStore.stores.apiStore;
    const { uiStore } = this.rootStore.stores;
    
    uiStore.setLoading(true);
    const response = await post<{ value: string }>(API_ACCOUNT_DETAIL_MOVEMENTS_CSV(this.accountId));
    
    if (response?.data) {
      this.generationDate = response.data.value;
      this.generationDialog = true;
    }

    uiStore.setLoading(false);
  };

  handleFilterSubmit = async (data: MovemensData) => {
    const { post } = this.rootStore.stores.apiStore;
    this.rootStore.stores.uiStore.setLoading(true);
    const filter = data.filter;
    const response = await post<MovemensData>(API_ACCOUNT_DETAIL_MOVEMENTS(this.accountId), {
      filter,
    });

    if (response?.data) {
      this.data = response?.data;
      this.data.movements = this.data.movements.map((m, i) => ({ ...m, id: `${i}` }));
    }

    this.rootStore.stores.uiStore.setLoading(false);
  };
}
